import React, { useState } from 'react';
import { CaretDown, SquaresFour } from '@phosphor-icons/react';
import { roofIncludedMultiplierDetail } from '../lib/preContractPpwPricing';
import type { PreContractRoofModuleLayout } from '../lib/preContractTypes';
import { RoofModuleBoard } from './PreContractModuleStep';

export type PreContractAiConfigSubsectionProps = {
    layouts: PreContractRoofModuleLayout[];
    includeGreyPanels: boolean;
    includePurplePanels: boolean;
    panelId: string;
    /** Dark cards in the solar layout All Designs grid. */
    tone?: 'light' | 'dark';
};

/** Icon that expands a small roof-layout preview inside a design card. */
export const PreContractAiConfigSubsection: React.FC<PreContractAiConfigSubsectionProps> = ({
    layouts,
    includeGreyPanels,
    includePurplePanels,
    panelId,
    tone = 'light',
}) => {
    const [open, setOpen] = useState(false);
    const displayLayouts = [...layouts].sort((a, b) => a.roofIndex - b.roofIndex);

    return (
        <div
            className={`pci-ai-config-sub pci-ai-config-sub--${tone}${
                open ? ' pci-ai-config-sub--open' : ''
            }`}
        >
            <button
                type="button"
                className="pci-ai-config-sub__toggle"
                aria-expanded={open}
                aria-controls={panelId}
                aria-label="View roof layout"
                title="View roof layout"
                onClick={(event) => {
                    event.stopPropagation();
                    setOpen((value) => !value);
                }}
                onKeyDown={(event) => event.stopPropagation()}
            >
                <SquaresFour size={14} weight="bold" aria-hidden />
                <CaretDown
                    className="pci-ai-config-sub__caret"
                    size={12}
                    weight="bold"
                    aria-hidden
                />
            </button>
            {open ? (
                <div
                    id={panelId}
                    className="pci-ai-config-sub__panel"
                    role="region"
                    aria-label="Roof layout"
                    onClick={(event) => event.stopPropagation()}
                    onKeyDown={(event) => event.stopPropagation()}
                >
                    {displayLayouts.length > 0 ? (
                        <div className="pci-module-layout-grid pci-ai-config-sub__layout">
                            {displayLayouts.map((layout) => {
                                const roofActive = layout.modules.some((cell) =>
                                    Boolean(cell?.included),
                                );
                                return (
                                    <RoofModuleBoard
                                        key={`${panelId}-${layout.roofIndex}`}
                                        layout={layout}
                                        multiplierDetail={
                                            roofActive
                                                ? roofIncludedMultiplierDetail(layout)
                                                : {
                                                      multiplier: null,
                                                      meanSolarAccess: null,
                                                      includedCount: 0,
                                                  }
                                        }
                                        inactive={!roofActive}
                                        includeGreyPanels={includeGreyPanels}
                                        includePurplePanels={includePurplePanels}
                                        compact
                                        readOnly
                                        onToggleRoof={() => undefined}
                                        onToggle={() => undefined}
                                        onHover={() => undefined}
                                    />
                                );
                            })}
                        </div>
                    ) : (
                        <p className="pci-ai-config-sub__empty">No roof layout yet</p>
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default PreContractAiConfigSubsection;
